import { render, staticRenderFns } from "./footer_en.vue?vue&type=template&id=8820895a&"
import script from "./footer_en.vue?vue&type=script&lang=js&"
export * from "./footer_en.vue?vue&type=script&lang=js&"
import style0 from "./footer_en.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports